export type Nullable<TType> = TType | null;

export type NullableFields<T> = {
  [K in keyof T]: Nullable<T[K]>;
};

export interface BoltValidationError {
  code: number;
  message: string;
  validation_errors?: {
    error: string;
    property: string;
  }[];
}

export enum StandardErrorCodes {
  SIGNUP_SERVER_ERROR = 453690,
  DUPLICATE_ACCOUNT = 453682,
}

/**
 * Example switch use case
 * switch( prop ) {
 *     case Enum.Val1
 *      return "A"
 *     case Enum.Val2
 *      return "B"
 *     default
 *      return new UnreachableCode(prop, "C")
 * }
 */
export class UnreachableCode {
  /**
   * Will give compilation error, if code might be reached (new enum value added, for example)
   *
   * @param input value used for the switch
   * @param defaultValue value the function will return at runtime. (No Error is thrown).
   */
  public static never<T>(_input: never, defaultValue?: T): T | undefined {
    return defaultValue;
  }
}
